export default "__VITE_ASSET__Bvkh48HW__"